module.exports = __webpack_public_path__ + "img/postgres.2818a4a5.svg";